import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = false

const infoAssignDriverPopupSlice = createSlice({
  name: 'infoAssignDriverPopup',
  initialState,
  reducers: {
    updateInfoAssignDriverPopup: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})

export const infoAssignDriverPopupActionsCreator = infoAssignDriverPopupSlice.actions

export default infoAssignDriverPopupSlice
